import { configureStore } from "@reduxjs/toolkit";
import { combineReducers,Reducer } from "redux";
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';

import configReducer, { ConfigState } from "./config/config.reducer";
import queNumberReducer, { QueueNumberState } from "./queue/queue.reducer";

export interface ApplicationState {
    configState: ConfigState,
    queueNumberState: QueueNumberState
}
export const ItemStateReducerMap: { [K in keyof ApplicationState]: Reducer<any> } = {
    configState: configReducer,
    queueNumberState: queNumberReducer
};

const rootPersistConfig = {
    key: 'root',
    storage,
}

const rootReducers = combineReducers(ItemStateReducerMap)
const persistedReducer = persistReducer(rootPersistConfig, rootReducers)
export const store = configureStore({
    reducer: persistedReducer,
    devTools: process.env.NODE_ENV !== 'production',
    middleware: [thunk]
})
export const persistor = persistStore(store)